import React from 'react';
import './loading.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Loading () {
    return(
        <FontAwesomeIcon className="loading-spinner" icon="spinner"/>
    )
}

export default Loading;